// src/components/Pages/MagicMirror/mirrorArt.ts
var MIRROR_THEMES = {
  halloween: {
    id: "halloween",
    label: "Halloween",
    kinds: ["ghost", "bat", "pumpkin", "sweet", "candyCorn", "star"],
    noun: "ghosts",
    colors: ["#ff9f1c", "#ffd166", "#f4f1de", "#c77dff", "#8ac926"],
    tile: { fill: "#ff9f1c", edge: "#7b3f00", ink: "#2b1a05" },
    accent: "#ff9f1c",
    accentAlt: "#c77dff",
    backdrop: ["#2a1246", "#3d1a5c", "#0f0a1e"]
  },
  christmas: {
    id: "christmas",
    label: "Christmas",
    kinds: ["bauble", "snowflake", "star", "candyCane", "present", "bell"],
    noun: "decorations",
    colors: ["#e63946", "#f1faee", "#a8dadc", "#2a9d8f", "#ffd166"],
    tile: { fill: "#e63946", edge: "#7f1d1d", ink: "#fff7ed" },
    accent: "#e63946",
    accentAlt: "#2a9d8f",
    backdrop: ["#0f2b3c", "#123f4f", "#071a24"]
  },
  bubbles: {
    id: "bubbles",
    label: "Bubbles",
    kinds: ["bubble", "bubbleSmall", "bubbleBig"],
    noun: "bubbles",
    colors: ["#a8dadc", "#ffffff", "#caf0f8", "#bde0fe", "#e0c3fc"],
    tile: { fill: "#bde0fe", edge: "#1d3557", ink: "#1d3557" },
    accent: "#4cc9f0",
    accentAlt: "#e0c3fc",
    backdrop: ["#0b3954", "#1b6f8a", "#06202e"]
  }
};
var resolveMirrorTheme = (id) => MIRROR_THEMES[id ?? "halloween"] ?? MIRROR_THEMES.halloween;
var circle = (ctx, x, y, r) => {
  ctx.beginPath();
  ctx.arc(x, y, r, 0, Math.PI * 2);
  ctx.closePath();
};
var smileyFace = (ctx, x, y, r, ink) => {
  ctx.fillStyle = ink;
  circle(ctx, x - r * 0.28, y - r * 0.12, r * 0.11);
  ctx.fill();
  circle(ctx, x + r * 0.28, y - r * 0.12, r * 0.11);
  ctx.fill();
  ctx.strokeStyle = ink;
  ctx.lineWidth = Math.max(2, r * 0.09);
  ctx.lineCap = "round";
  ctx.beginPath();
  ctx.arc(x, y + r * 0.1, r * 0.34, 0.15 * Math.PI, 0.85 * Math.PI);
  ctx.stroke();
};
var drawGhost = (ctx, x, y, r) => {
  ctx.fillStyle = "#f7f7ff";
  ctx.beginPath();
  ctx.arc(x, y - r * 0.15, r * 0.78, Math.PI, 0);
  ctx.lineTo(x + r * 0.78, y + r * 0.5);
  for (let i = 0; i < 3; i++) {
    const w = r * 1.56 / 3;
    const left = x + r * 0.78 - w * i;
    ctx.arc(left - w / 2, y + r * 0.5, w / 2, 0, Math.PI, i % 2 === 0);
  }
  ctx.lineTo(x - r * 0.78, y - r * 0.15);
  ctx.closePath();
  ctx.fill();
  smileyFace(ctx, x, y - r * 0.15, r * 0.7, "#4b3f72");
};
var drawBat = (ctx, x, y, r) => {
  ctx.fillStyle = "#6a4c93";
  ctx.beginPath();
  ctx.moveTo(x, y);
  ctx.quadraticCurveTo(x - r * 0.7, y - r * 0.6, x - r, y + r * 0.05);
  ctx.quadraticCurveTo(x - r * 0.55, y + r * 0.12, x - r * 0.35, y + r * 0.42);
  ctx.quadraticCurveTo(x - r * 0.2, y + r * 0.15, x, y + r * 0.35);
  ctx.quadraticCurveTo(x + r * 0.2, y + r * 0.15, x + r * 0.35, y + r * 0.42);
  ctx.quadraticCurveTo(x + r * 0.55, y + r * 0.12, x + r, y + r * 0.05);
  ctx.quadraticCurveTo(x + r * 0.7, y - r * 0.6, x, y);
  ctx.closePath();
  ctx.fill();
  circle(ctx, x, y + r * 0.02, r * 0.34);
  ctx.fill();
  circle(ctx, x - r * 0.22, y - r * 0.28, r * 0.13);
  ctx.fill();
  circle(ctx, x + r * 0.22, y - r * 0.28, r * 0.13);
  ctx.fill();
  smileyFace(ctx, x, y + r * 0.05, r * 0.32, "#ffd166");
};
var drawPumpkin = (ctx, x, y, r) => {
  ctx.fillStyle = "#ff9f1c";
  ctx.save();
  ctx.translate(x, y + r * 0.08);
  ctx.scale(1.12, 1);
  circle(ctx, 0, 0, r * 0.78);
  ctx.fill();
  ctx.restore();
  ctx.strokeStyle = "rgba(180, 90, 0, 0.55)";
  ctx.lineWidth = Math.max(1.5, r * 0.06);
  for (const offset of [-0.4, 0, 0.4]) {
    ctx.beginPath();
    ctx.ellipse(
      x + r * offset,
      y + r * 0.08,
      r * 0.22,
      r * 0.78,
      0,
      0,
      Math.PI * 2
    );
    ctx.stroke();
  }
  ctx.fillStyle = "#4a7c59";
  ctx.fillRect(x - r * 0.08, y - r * 0.95, r * 0.16, r * 0.3);
  smileyFace(ctx, x, y + r * 0.12, r * 0.7, "#5a2d0c");
};
var drawSweet = (ctx, x, y, r) => {
  ctx.fillStyle = "#ef476f";
  circle(ctx, x, y, r * 0.55);
  ctx.fill();
  ctx.fillStyle = "#ffd166";
  for (const dir of [-1, 1]) {
    ctx.beginPath();
    ctx.moveTo(x + dir * r * 0.5, y);
    ctx.lineTo(x + dir * r, y - r * 0.4);
    ctx.lineTo(x + dir * r, y + r * 0.4);
    ctx.closePath();
    ctx.fill();
  }
  ctx.fillStyle = "rgba(255,255,255,0.7)";
  circle(ctx, x - r * 0.18, y - r * 0.18, r * 0.12);
  ctx.fill();
};
var drawCandyCorn = (ctx, x, y, r) => {
  const top = y - r * 0.8;
  const bottom = y + r * 0.8;
  const bands = [
    ["#ffd166", 0, 0.36],
    ["#ff9f1c", 0.36, 0.7],
    ["#fffdf5", 0.7, 1]
  ];
  for (const [color, from, to] of bands) {
    const yA = top + (bottom - top) * from;
    const yB = top + (bottom - top) * to;
    const wA = r * (0.1 + from * 0.62);
    const wB = r * (0.1 + to * 0.62);
    ctx.fillStyle = color;
    ctx.beginPath();
    ctx.moveTo(x - wA, yA);
    ctx.lineTo(x + wA, yA);
    ctx.lineTo(x + wB, yB);
    ctx.lineTo(x - wB, yB);
    ctx.closePath();
    ctx.fill();
  }
};
var drawStar = (ctx, x, y, r) => {
  ctx.fillStyle = "#ffd166";
  ctx.beginPath();
  for (let i = 0; i < 10; i++) {
    const radius = i % 2 === 0 ? r * 0.85 : r * 0.36;
    const angle = i / 10 * Math.PI * 2 - Math.PI / 2;
    const px = x + Math.cos(angle) * radius;
    const py = y + Math.sin(angle) * radius;
    if (i === 0) ctx.moveTo(px, py);
    else ctx.lineTo(px, py);
  }
  ctx.closePath();
  ctx.fill();
  ctx.fillStyle = "rgba(255,255,255,0.55)";
  circle(ctx, x - r * 0.15, y - r * 0.2, r * 0.12);
  ctx.fill();
};
var drawBauble = (ctx, x, y, r) => {
  const gradient = ctx.createRadialGradient(
    x - r * 0.3,
    y - r * 0.2,
    r * 0.1,
    x,
    y + r * 0.1,
    r * 0.85
  );
  gradient.addColorStop(0, "#ff8fa3");
  gradient.addColorStop(1, "#c1121f");
  ctx.fillStyle = gradient;
  circle(ctx, x, y + r * 0.1, r * 0.75);
  ctx.fill();
  ctx.fillStyle = "#ffd166";
  ctx.fillRect(x - r * 0.18, y - r * 0.85, r * 0.36, r * 0.24);
  ctx.strokeStyle = "#ffd166";
  ctx.lineWidth = Math.max(2, r * 0.08);
  ctx.beginPath();
  ctx.arc(x, y - r * 0.9, r * 0.16, Math.PI, 0);
  ctx.stroke();
  ctx.fillStyle = "rgba(255,255,255,0.5)";
  circle(ctx, x - r * 0.26, y - r * 0.1, r * 0.14);
  ctx.fill();
};
var drawSnowflake = (ctx, x, y, r) => {
  ctx.strokeStyle = "#f1faee";
  ctx.lineWidth = Math.max(2, r * 0.11);
  ctx.lineCap = "round";
  for (let i = 0; i < 6; i++) {
    const angle = i / 6 * Math.PI * 2;
    const dx = Math.cos(angle);
    const dy = Math.sin(angle);
    ctx.beginPath();
    ctx.moveTo(x, y);
    ctx.lineTo(x + dx * r * 0.85, y + dy * r * 0.85);
    ctx.stroke();
    for (const side of [-1, 1]) {
      const bx = x + dx * r * 0.5;
      const by = y + dy * r * 0.5;
      const branch = angle + side * 0.7;
      ctx.beginPath();
      ctx.moveTo(bx, by);
      ctx.lineTo(
        bx + Math.cos(branch) * r * 0.3,
        by + Math.sin(branch) * r * 0.3
      );
      ctx.stroke();
    }
  }
};
var drawCandyCane = (ctx, x, y, r) => {
  ctx.save();
  ctx.translate(x, y);
  ctx.lineCap = "round";
  ctx.lineWidth = r * 0.34;
  const path = new Path2D();
  path.moveTo(-r * 0.05, r * 0.85);
  path.lineTo(-r * 0.05, -r * 0.3);
  path.arc(r * 0.3, -r * 0.3, r * 0.35, Math.PI, 0);
  ctx.strokeStyle = "#f1faee";
  ctx.stroke(path);
  ctx.save();
  ctx.lineWidth = r * 0.34;
  ctx.strokeStyle = "#e63946";
  ctx.setLineDash([r * 0.22, r * 0.22]);
  ctx.stroke(path);
  ctx.restore();
  ctx.restore();
};
var drawPresent = (ctx, x, y, r) => {
  const size = r * 1.4;
  ctx.fillStyle = "#2a9d8f";
  ctx.beginPath();
  ctx.roundRect(
    x - size / 2,
    y - size / 2 + r * 0.1,
    size,
    size * 0.85,
    r * 0.16
  );
  ctx.fill();
  ctx.fillStyle = "#ffd166";
  ctx.fillRect(x - r * 0.12, y - size / 2 + r * 0.1, r * 0.24, size * 0.85);
  ctx.fillRect(x - size / 2, y - r * 0.1, size, r * 0.24);
  ctx.beginPath();
  ctx.ellipse(
    x - r * 0.28,
    y - size / 2 + r * 0.02,
    r * 0.26,
    r * 0.18,
    0,
    0,
    Math.PI * 2
  );
  ctx.ellipse(
    x + r * 0.28,
    y - size / 2 + r * 0.02,
    r * 0.26,
    r * 0.18,
    0,
    0,
    Math.PI * 2
  );
  ctx.fill();
};
var drawBell = (ctx, x, y, r) => {
  ctx.fillStyle = "#ffd166";
  ctx.beginPath();
  ctx.moveTo(x - r * 0.68, y + r * 0.5);
  ctx.quadraticCurveTo(x - r * 0.6, y - r * 0.7, x, y - r * 0.75);
  ctx.quadraticCurveTo(x + r * 0.6, y - r * 0.7, x + r * 0.68, y + r * 0.5);
  ctx.closePath();
  ctx.fill();
  ctx.fillStyle = "#e9a800";
  ctx.beginPath();
  ctx.roundRect(x - r * 0.78, y + r * 0.45, r * 1.56, r * 0.22, r * 0.11);
  ctx.fill();
  circle(ctx, x, y + r * 0.78, r * 0.17);
  ctx.fill();
};
var drawBubble = (ctx, x, y, r, scale) => {
  const radius = r * scale;
  const gradient = ctx.createRadialGradient(
    x - radius * 0.3,
    y - radius * 0.3,
    radius * 0.05,
    x,
    y,
    radius
  );
  gradient.addColorStop(0, "rgba(255,255,255,0.55)");
  gradient.addColorStop(0.55, "rgba(173, 216, 240, 0.22)");
  gradient.addColorStop(1, "rgba(190, 160, 240, 0.35)");
  ctx.fillStyle = gradient;
  circle(ctx, x, y, radius);
  ctx.fill();
  ctx.strokeStyle = "rgba(255,255,255,0.75)";
  ctx.lineWidth = Math.max(1.5, radius * 0.06);
  circle(ctx, x, y, radius * 0.97);
  ctx.stroke();
  ctx.fillStyle = "rgba(255,255,255,0.85)";
  ctx.beginPath();
  ctx.ellipse(
    x - radius * 0.35,
    y - radius * 0.4,
    radius * 0.2,
    radius * 0.13,
    -0.6,
    0,
    Math.PI * 2
  );
  ctx.fill();
};
var drawMirrorItem = (ctx, art, x, y, r) => {
  ctx.save();
  switch (art) {
    case "ghost":
      drawGhost(ctx, x, y, r);
      break;
    case "bat":
      drawBat(ctx, x, y, r);
      break;
    case "pumpkin":
      drawPumpkin(ctx, x, y, r);
      break;
    case "sweet":
      drawSweet(ctx, x, y, r);
      break;
    case "candyCorn":
      drawCandyCorn(ctx, x, y, r);
      break;
    case "bauble":
      drawBauble(ctx, x, y, r);
      break;
    case "snowflake":
      drawSnowflake(ctx, x, y, r);
      break;
    case "candyCane":
      drawCandyCane(ctx, x, y, r);
      break;
    case "present":
      drawPresent(ctx, x, y, r);
      break;
    case "bell":
      drawBell(ctx, x, y, r);
      break;
    case "bubble":
      drawBubble(ctx, x, y, r, 1);
      break;
    case "bubbleSmall":
      drawBubble(ctx, x, y, r, 0.68);
      break;
    case "bubbleBig":
      drawBubble(ctx, x, y, r, 1.25);
      break;
    default:
      drawStar(ctx, x, y, r);
      break;
  }
  ctx.restore();
};
var drawLetterTile = (ctx, letter, x, y, r, theme, wobble = 0) => {
  ctx.save();
  ctx.translate(x, y);
  if (wobble > 0) ctx.rotate(Math.sin(wobble * Math.PI * 6) * 0.35 * wobble);
  const size = r * 1.6;
  ctx.fillStyle = theme.tile.edge;
  ctx.beginPath();
  ctx.roundRect(-size / 2, -size / 2 + r * 0.08, size, size, r * 0.28);
  ctx.fill();
  ctx.fillStyle = theme.tile.fill;
  ctx.beginPath();
  ctx.roundRect(-size / 2, -size / 2, size, size, r * 0.28);
  ctx.fill();
  ctx.fillStyle = theme.tile.ink;
  ctx.font = `bold ${Math.round(r * 1.05)}px system-ui, -apple-system, "Segoe UI", sans-serif`;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.save();
  ctx.scale(-1, 1);
  ctx.fillText(letter, 0, r * 0.04);
  ctx.restore();
  ctx.restore();
};
var drawHandSparkle = (ctx, x, y, t) => {
  const pulse = 1 + Math.sin(t * 5) * 0.12;
  const r = 26 * pulse;
  ctx.save();
  const glow = ctx.createRadialGradient(x, y, 0, x, y, r * 1.8);
  glow.addColorStop(0, "rgba(255, 255, 255, 0.85)");
  glow.addColorStop(0.35, "rgba(180, 220, 255, 0.45)");
  glow.addColorStop(1, "rgba(180, 220, 255, 0)");
  ctx.fillStyle = glow;
  circle(ctx, x, y, r * 1.8);
  ctx.fill();
  ctx.fillStyle = "rgba(255,255,255,0.95)";
  ctx.beginPath();
  for (let i = 0; i < 8; i++) {
    const radius = i % 2 === 0 ? r : r * 0.28;
    const angle = i / 8 * Math.PI * 2 - Math.PI / 2;
    const px = x + Math.cos(angle) * radius;
    const py = y + Math.sin(angle) * radius;
    if (i === 0) ctx.moveTo(px, py);
    else ctx.lineTo(px, py);
  }
  ctx.closePath();
  ctx.fill();
  ctx.restore();
};
var drawParticles = (ctx, particles) => {
  ctx.save();
  for (const particle of particles) {
    ctx.globalAlpha = Math.max(
      0,
      Math.min(1, particle.life / particle.maxLife)
    );
    ctx.fillStyle = particle.color;
    circle(ctx, particle.x, particle.y, particle.size);
    ctx.fill();
  }
  ctx.restore();
};

export {
  resolveMirrorTheme,
  drawMirrorItem,
  drawLetterTile,
  drawHandSparkle,
  drawParticles
};
//# sourceMappingURL=chunk-ZUBYS2Q3.mjs.map